import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoPatientStatusModalTemplate } from 'themes/application/niko-patient/components';
import { NikoPatientStatusModalStore } from 'application/niko-patient/stores';

@setCurrentView((rootStore, componentProps) => new NikoPatientStatusModalStore(rootStore, componentProps), 'nikoPatientStatusModalStore')
@observer
class NikoPatientStatusModal extends React.Component {
    render() {
        return <NikoPatientStatusModalTemplate {...this.props} />
    }
}

export default NikoPatientStatusModal;